<template>
    <!-- <img :src="'images/Background_Login.png'" class="h-full w-full" :alt="urlImageAlt" cache /> -->

    <div class="py-8 px-8 lg:py-16 lg:px-20  bg-primary min-h-screen">
        <img :src="'/images/av_hrs_putih.png'" :alt="altImageLogo" class="w-28 lg:w-40" cache />
        <h1 class="text-white font-bold mt-4 text-sm italic lg:text-xl">
            Manage Attadance, leave and payroll.
        </h1>
        <div class="rounded-xl bg-white mt-8">
            <div class="lg:px-10 md:px-6 px-4 py-8">
                <div class="flex flex-col justify-between sm:items-center gap-x-5 gap-y-5 sm:flex-row">
                    <div>
                        <h1 class="text-2xl font-semibold leading-6 text-slate-800">
                            Privacy Policy
                        </h1>
                        <p class="mt-4 text-base text-gray-600">
                            Here are our privacy policies.
                        </p>
                    </div>
                </div>


                <div class="flex flex-col gap-y-7 mt-7">
                    <h4 class="font-semibold"> Kebijakan Privasi </h4>
                    <p> AVHrs dimiliki oleh Armada Vision, yang akan menjadi pengontrol atas data pribadi Anda. </p>
                    <p> Kami telah mengadopsi Kebijakan Privasi ini untuk menjelaskan bagaimana kami memproses informasi
                        yang dikumpulkan oleh AVHrs, yang juga menjelaskan alasan mengapa kami perlu mengumpulkan data
                        pribadi tertentu tentang Anda. Oleh karena itu, Anda harus membaca Kebijakan Privasi ini sebelum
                        menggunakan website AVHrs. </p>
                    <p> Kami menjaga data pribadi Anda dan berjanji untuk menjamin kerahasiaan dan keamanannya. </p>
                    <h4 class="font-semibold"> Informasi pribadi yang kami kumpulkan: </h4>
                    <p> Saat Anda mengunjungi AVHrs, kami secara otomatis mengumpulkan informasi tertentu mengenai
                        perangkat Anda, termasuk informasi tentang browser web, alamat IP, zona waktu, dan sejumlah cookie
                        yang terinstal di perangkat Anda. Selain itu, selama Anda menjelajahi Website, kami mengumpulkan
                        informasi tentang setiap halaman web atau produk yang Anda lihat, website atau istilah pencarian apa
                        yang mengarahkan Anda ke Website, dan cara Anda berinteraksi dengan Website. Kami menyebut informasi
                        yang dikumpulkan secara otomatis ini sebagai "Informasi Perangkat". Kemudian, kami mungkin akan
                        mengumpulkan data pribadi yang Anda berikan kepada kami (termasuk tetapi tidak terbatas pada, Nama,
                        Nama belakang, Alamat, informasi pembayaran, dll.) selama pendaftaran untuk dapat memenuhi
                        perjanjian. </p>
                    <h4 class="font-semibold"> Mengapa kami memproses data Anda? </h4>
                    <p> Menjaga data pelanggan agar tetap aman adalah prioritas utama kami. Oleh karena itu, kami hanya
                        dapat memproses sejumlah kecil data pengguna, sebanyak yang benar-benar diperlukan untuk menjalankan
                        website. Informasi yang dikumpulkan secara otomatis hanya digunakan untuk mengidentifikasi
                        kemungkinan kasus penyalahgunaan dan menyusun informasi statistik terkait penggunaan website.
                        Informasi statistik ini tidak digabungkan sedemikian rupa hingga dapat mengidentifikasi pengguna
                        tertentu dari sistem. </p>
                    <p> Anda dapat mengunjungi website tanpa memberi tahu kami identitas Anda atau mengungkapkan informasi
                        apa pun, yang dapat digunakan oleh seseorang untuk mengidentifikasi Anda sebagai individu tertentu
                        yang dapat dikenali. Namun, jika Anda ingin menggunakan beberapa fitur website, atau Anda ingin
                        menerima newsletter kami atau memberikan detail lainnya dengan mengisi formulir, Anda dapat
                        memberikan data pribadi kepada kami, seperti email, nama depan, nama belakang, kota tempat tinggal,
                        organisasi, dan nomor telepon Anda. Anda dapat memilih untuk tidak memberikan data pribadi Anda
                        kepada kami, tetapi Anda mungkin tidak dapat memanfaatkan beberapa fitur website. Contohnya, Anda
                        tidak akan dapat menerima Newsletter kami atau menghubungi kami secara langsung dari website.
                        Pengguna yang tidak yakin tentang informasi yang wajib diberikan dapat menghubungi kami melalui
                        armadavisiondeveloper@gmail.com. </p>
                    <h4 class="font-semibold"> Hak-hak Anda: </h4>
                    <p> Jika Anda seorang warga Eropa, Anda memiliki hak-hak berikut terkait data pribadi Anda: </p>
                    <ul>
                        <li> Hak untuk mendapatkan penjelasan. </li>
                        <li> Hak atas akses. </li>
                        <li> Hak untuk memperbaiki. </li>
                        <li> Hak untuk menghapus. </li>
                        <li> Hak untuk membatasi pemrosesan. </li>
                        <li> Hak atas portabilitas data. </li>
                        <li> Hak untuk menolak. </li>
                        <li> Hak-hak terkait pengambilan keputusan dan pembuatan profil otomatis. </li>
                    </ul>
                    <p> Jika Anda ingin menggunakan hak ini, silakan hubungi kami melalui informasi kontak di bawah ini.
                    </p>
                    <p> Selain itu, jika Anda seorang warga Eropa, perlu diketahui bahwa kami akan memproses informasi Anda
                        untuk memenuhi kontrak yang mungkin kami miliki dengan Anda (misalnya, jika Anda melakukan pemesanan
                        melalui Website), atau untuk memenuhi kepentingan bisnis sah kami seperti yang tercantum di atas. Di
                        samping itu, harap diperhatikan bahwa informasi Anda mungkin dapat dikirim ke luar Eropa, termasuk
                        Kanada dan Amerika Serikat. </p>
                    <h4 class="font-semibold"> Link ke website lain: </h4>
                    <p> Website kami mungkin berisi tautan ke website lain yang tidak dimiliki atau dikendalikan oleh kami.
                        Perlu diketahui bahwa kami tidak bertanggung jawab atas praktik privasi website lain atau pihak
                        ketiga. Kami menyarankan Anda untuk selalu waspada ketika meninggalkan website kami dan membaca
                        pernyataan privasi setiap website yang mungkin mengumpulkan informasi pribadi. </p>
                    <h4 class="font-semibold"> Penggunaan Data Wajah: </h4>
                    <p> Aplikasi kami tidak akan menyimpan atau menyalin foto/gambar yang di gunakan saat mendaftar,masuk dan melakukan proses absensi,
                        foto/gambar yang diambil hanya untuk validasi masing - masing karyawan lalu akan otomotatis di hapus oleh system kami. </p>
                    <h4 class="font-semibold"> Penggunaan Data Lokasi: </h4>
                    <p> Kami menggunakan akses lokasi untuk melakukan validasi terkait lokasi absensi yang sudah di tentukan masing - masing perusahaan dengan
                        lokasi user. </p>
                    <h4 class="font-semibold"> Keamanan informasi: </h4>
                    <p> Kami menjaga keamanan informasi yang Anda berikan pada server komputer dalam lingkungan yang
                        terkendali, aman, dan terlindungi dari akses, penggunaan, atau pengungkapan yang tidak sah. Kami
                        menjaga pengamanan administratif, teknis, dan fisik yang wajar untuk perlindungan terhadap akses,
                        penggunaan, modifikasi, dan pengungkapan tidak sah atas data pribadi dalam kendali dan
                        pengawasannya. Namun, kami tidak menjamin tidak akan ada transmisi data melalui Internet atau
                        jaringan nirkabel. </p>
                    <h4 class="font-semibold"> Pengungkapan hukum: </h4>
                    <p> Kami akan mengungkapkan informasi apa pun yang kami kumpulkan, gunakan, atau terima jika diwajibkan
                        atau diizinkan oleh hukum, misalnya untuk mematuhi panggilan pengadilan atau proses hukum serupa,
                        dan jika kami percaya dengan itikad baik bahwa pengungkapan diperlukan untuk melindungi hak kami,
                        melindungi keselamatan Anda atau keselamatan orang lain, menyelidiki penipuan, atau menanggapi
                        permintaan dari pemerintah. </p>
                    <h4 class="font-semibold"> Informasi kontak: </h4>
                    <p> Jika Anda ingin menghubungi kami untuk mempelajari Kebijakan ini lebih lanjut atau menanyakan
                        masalah apa pun yang berkaitan dengan hak perorangan dan Informasi pribadi Anda, Anda dapat mengirim
                        email ke armadavisiondeveloper@gmail.com. </p>
                </div>
            </div>


            <!-- <h1 class="font-semibold text-2xl text-gray-500 mb-4">Privacy & Policy</h1>

            <div class="mb-4">
                <p>At AVHrs, accessible from mufidahgroup.com, one of our main priorities is the privacy of our client. This
                    Privacy
                    Policy document contains types of information that is collected and recorded by AVHrs and how we use it.
                </p>

                <p>If you have additional questions or require more information about our Privacy Policy, do not hesitate to
                    contact us.</p>

            </div> -->
            <!-- <h2>Log Files</h2>

            <p>AVHrs follows a standard procedure of using log files. These files log visitors when they visit websites. All
                hosting companies do this and a part of hosting services' analytics. The information collected by log files
                include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time
                stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that
                is personally identifiable. The purpose of the information is for analyzing trends, administering the site,
                tracking users' movement on the website, and gathering demographic information.</p> -->

            <!-- <h2 class="font-semibold text-xl text-gray-500 mb-4">Cookies and Web Beacons</h2>

            <div class="mb-4">
                <p>Like any other website, AVHrs uses "cookies". These cookies are used to store information including users
                    preferences, and the pages on the website that the user accessed or visited. The information is used to
                    optimize the users' experience by customizing our web page content based on visitors' browser type
                    and/or
                    other information.</p>
            </div>

            <h2 class="font-semibold text-xl text-gray-500 mb-4">Privacy Policies</h2>

            <P>You may consult this list to find the Privacy Policy for each of the advertising partners of AVHrs.</p>

            <div class="mb-4">
                <div class="mb-4">
                    <p>Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that
                        are
                        used in their respective advertisements and links that appear on AVHrs, which are sent directly to
                        users'
                        browser. They automatically receive your IP address when this occurs. These technologies are used to
                        measure
                        the effectiveness of their advertising campaigns and/or to personalize the advertising content that
                        you
                        see
                        on websites that you visit.</p>
                </div>

                <p class="font-semibold text-gray-600">Note: AVHrs has no access to or control over these cookies that are used by third-party advertisers.
                </p>
            </div>

            <h2 class="font-semibold text-xl text-gray-500 mb-4">Third Party Privacy Policies</h2>

            <div class="mb-4">
                <p>AVHrs's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to
                    consult
                    the respective Privacy Policies of these third-party ad servers for more detailed information. It may
                    include their practices and instructions about how to opt-out of certain options. </p>

                <p>You can choose to disable cookies through your individual browser options. To know more detailed
                    information
                    about cookie management with specific web browsers, it can be found at the browsers' respective
                    websites.
                    What Are Cookies?</p>
            </div>

            <h2 class="font-semibold text-xl text-gray-500 mb-4">Online Privacy Policy Only</h2>

            <div class="mb-4">
                <p>This Privacy Policy applies only to our online activities and is valid for visitors to our website with
                    regards to the information that they shared and/or collect in AVHrs. This policy is not applicable to
                    any
                    information collected offline or via channels other than this website.</p>
            </div>
            <h2 class="font-semibold text-xl text-gray-500 mb-4">Consent</h2>

            <div class="mb-4">
                <p>By using our website, you hereby consent to our Privacy Policy and agree to its Terms and Conditions.</p>
            </div> -->
        </div>
    </div>
</template>

<script>
import Button from "../components/Button.vue";
import { SECRET_KEY } from "@/config";
import Loading from "@/components/Loading.vue";
import { useToast } from "vue-toastification";

export default {
    name: "Privacy And Policy",
    components: { Button, Loading },
    data() {
        return {
            altImageLogo: "Logo avapps",
            urlImageAlt: "Backgound Login Image",
            loading: false,
            capslockOn: false,
        };
    },
    setup() {
        const toast = useToast();
        return { toast };
    },
    methods: {
        detectCapsLock(event) {
            this.capslockOn =
                event.getModifierState && event.getModifierState("CapsLock");
        },
    },
};
</script>

<style scoped>.tooltip::before {
    content: "";
    display: block;
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 8px;
    border-style: solid;
    border-color: transparent transparent #979797 transparent;
}</style>